import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
/**
 * Created by commyfeng on 2017/3/21.
 */

import RequestErrorType from "../lib/RequestErrorType";
import RequestError from "../lib/RequestError";
function timeout(time) {
  return new Promise(function (resolve, reject) {
    setTimeout(function () {
      reject(new RequestError(-1, "\u8BF7\u6C42\u8D85\u65F6(".concat(time / 1000, "s)\uFF0C\u8BF7\u91CD\u8BD5"), null, RequestErrorType.NETWORK_ERR));
    }, time);
  });
}
export default function () {
  var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5000;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(next) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Promise.race([next(), timeout(time)]);
            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}